// src/etapas/EtapaProdutos.js
import React, { useState, useEffect } from 'react';

function EtapaProdutos({ onNext, onBack, setDados, dados }) {
  const [itens, setItens] = useState(dados.etapa5?.itens || []);
  const tipoServico = dados.tipoServico?.titulo || '';
  const maxItens = tipoServico === 'Frete Express' ? 5 : 9999;
  const [valorTotal, setValorTotal] = useState(dados.etapa5?.valorTotal || ''); // <<<

  useEffect(() => {
    if (dados.etapa5?.itens) {
      setItens(dados.etapa5.itens);
    }
  }, [dados.etapa5]);

  const adicionarItem = () => {
    if (itens.length >= maxItens) {
      alert('Limite máximo de itens atingido para este tipo de serviço.');
      return;
    }

    const novoItem = {
      numero: itens.length + 1,
      descricao: '',
      quantidade: '',
      altura: '',
      largura: '',
      comprimento: '',
      totalM3: '',
      fotos: []
    };

    setItens([...itens, novoItem]);
  };

  const atualizarItem = (index, campo, valor) => {
    const novosItens = [...itens];
    novosItens[index][campo] = valor;

    const { altura, largura, comprimento, quantidade } = novosItens[index];
    if (altura && largura && comprimento && quantidade) {
      const volumeUnitario = parseFloat(altura) * parseFloat(largura) * parseFloat(comprimento);
      const total = (volumeUnitario * parseInt(quantidade)).toFixed(3);
      novosItens[index].totalM3 = isNaN(total) ? '' : total;
    } else {
      novosItens[index].totalM3 = '';
    }


    setItens(novosItens);
  };

  const handleFotosChange = async (index, files) => {
    const novosItens = [...itens];
    const novasFotos = await Promise.all(Array.from(files).map(async (file) => {
      const base64 = await toBase64(file);
      return {
        nome: file.name,
        base64: base64.replace(/^data:.+;base64,/, '')
      };
    }));

    novosItens[index].fotos = [...(novosItens[index].fotos || []), ...novasFotos];
    setItens(novosItens);
  };

  const toBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };

  const removerFoto = (itemIndex, fotoIndex) => {
    const novosItens = [...itens];
    novosItens[itemIndex].fotos.splice(fotoIndex, 1);
    setItens(novosItens);
  };

  const cancelarItem = (index) => {
    const novosItens = [...itens];
    novosItens.splice(index, 1);
    setItens(novosItens);
  };

  const validarCampos = () => {
    if (itens.length === 0) return false;

    const ultimo = itens[itens.length - 1];
    const camposObrigatorios = ['descricao', 'quantidade', 'altura', 'largura', 'comprimento'];
    const faltando = camposObrigatorios.filter((campo) => !ultimo[campo]);

    if (faltando.length > 0) {
      alert('Preencha os seguintes campos do último item: ' + faltando.join(', '));
      return false;
    }

    return true;
  };

  const avancar = () => {
    if (!validarCampos()) return;

    setDados((prev) => ({
      ...prev,
      etapa5: {
        itens: itens.map((item) => ({
          numero: item.numero,
          descricao: item.descricao,
          quantidade: item.quantidade,
          altura: item.altura,
          largura: item.largura,
          comprimento: item.comprimento,
          totalM3: item.totalM3,
          fotos: item.fotos || []
        })),
        valorTotal: valorTotal // <<< incluído aqui
      }
    }));


    console.log('Dados recebidos na etapa 5:', dados);

    onNext();
  };

  return (
    <div className="container">
      <h4 className="fw-semibold text-center mb-4" style={{ fontSize: '1.5rem', color: '#444' }}>
        Itens a Transportar
      </h4>

      {itens.map((item, index) => (
        <div key={index} className="border p-3 mb-3 rounded">
          <div className="d-flex justify-content-between">
            <h6>Item {item.numero}</h6>
            <button className="btn btn-sm btn-outline-danger" onClick={() => cancelarItem(index)}>
              Cancelar Item
            </button>
          </div>
          <div className="row g-2">
            <div className="col-md-4">
              <label>Descrição</label>
              <input
                className="form-control"
                value={item.descricao}
                onChange={(e) => atualizarItem(index, 'descricao', e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <label>Quantidade</label>
              <input
                type="number"
                className="form-control"
                value={item.quantidade}
                onChange={(e) => atualizarItem(index, 'quantidade', e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <label>Altura (m)</label>
              <input
                type="number"
                className="form-control"
                value={item.altura}
                onChange={(e) => atualizarItem(index, 'altura', e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <label>Largura (m)</label>
              <input
                type="number"
                className="form-control"
                value={item.largura}
                onChange={(e) => atualizarItem(index, 'largura', e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <label>Comprimento (m)</label>
              <input
                type="number"
                className="form-control"
                value={item.comprimento}
                onChange={(e) => atualizarItem(index, 'comprimento', e.target.value)}
              />
            </div>
          </div>
          <div className="row g-2 mt-2">
            <div className="col-md-2">
              <label>Total m³</label>
              <input type="text" className="form-control" value={item.totalM3} disabled />
            </div>
          </div>
          <div className="mt-3">
            <label>Fotos do item:</label>
            <input
              type="file"
              className="form-control"
              multiple
              accept="image/*"
              onChange={(e) => handleFotosChange(index, e.target.files)}
            />
            <div className="d-flex flex-wrap gap-2 mt-2">
              {item.fotos?.map((foto, i) => (
                <div key={i} style={{ position: 'relative' }}>
                  <img
                    src={`data:image/*;base64,${foto.base64}`}
                    alt={`foto-${i}`}
                    style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '6px', cursor: 'pointer' }}
                    onClick={() => window.open(`data:image/*;base64,${foto.base64}`, '_blank')}
                  />
                  <button
                    className="btn-close position-absolute top-0 end-0"
                    style={{ backgroundColor: 'white' }}
                    onClick={() => removerFoto(index, i)}
                  ></button>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}

      <div className="row mt-4">
        <div className="col-md-4 offset-md-8">
          <label className="fw-semibold">Valor Total dos Produtos (R$)</label>
          <input
            type="number"
            className="form-control"
            value={valorTotal}
            onChange={(e) => setValorTotal(e.target.value)}
            placeholder="Ex: 1500.00"
          />
        </div>
      </div>


      <div className="d-flex justify-content-between mt-4">
        <button className="btn btn-secondary" onClick={onBack}>
          Voltar
        </button>
        <button className="btn btn-info" onClick={adicionarItem}>
          Adicionar Item
        </button>
        <button className="btn btn-success" onClick={avancar}>
          Avançar
        </button>
      </div>
    </div>
  );
}

export default EtapaProdutos;
